import createIcon from '../../createIcon';

/**
 * @component @name Duo
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMkgxMkM2LjM4IDIgMiA2LjY2IDIgMTIuMjhDMiAxNy41IDYuNDkgMjIgMTEuNzIgMjJDMTcuMzkgMjIgMjIgMTcuNjIgMjIgMTJWNEMyMiAyLjkgMjEuMSAyIDIwIDJaTTE3IDE1TDE0IDEzVjE1SDdWOUgxNFYxMUwxNyA5VjE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Duo = createIcon('Duo', [
  [
    'path',
    {
      d: 'M20 2H12C6.38 2 2 6.66 2 12.28C2 17.5 6.49 22 11.72 22C17.39 22 22 17.62 22 12V4C22 2.9 21.1 2 20 2ZM17 15L14 13V15H7V9H14V11L17 9V15Z',
      key: 'rvxr05',
    },
  ],
]);

export default Duo;
